import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { COLORS } from 'src/utils/Themes/colors'
import { useEffect, useState } from 'react'
import {
  CLAIM_GRAPH_TYPE_LABELS,
  CLAIM_GRAPH_TYPES,
} from 'src/utils/constants/common'
import './graphStyles.css'
import CustomAxisTick from 'src/components/RiskReports/PendingClaims/CustomAxisTick'
import CustomGraphTooltip from 'src/components/RiskReports/PendingClaims/CustomGraphTooltip'

const GeneralPendingClaimChart = ({
  employeeBenefitsData,
  nonEmployeeBenefitsData,
}) => {
  const [graphData, setGraphData] = useState([])

  useEffect(() => {
    createGraphData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeBenefitsData, nonEmployeeBenefitsData])

  const createGraphData = () => {
    if (employeeBenefitsData || nonEmployeeBenefitsData) {
      let formattedGraphData = []
      Object.keys(CLAIM_GRAPH_TYPES)?.forEach((graphDataKey) => {
        formattedGraphData.push({
          name: CLAIM_GRAPH_TYPE_LABELS?.[graphDataKey],
          type: graphDataKey,
          ebClaimCount: employeeBenefitsData?.[graphDataKey]?.count ?? 0,
          ebClaimAmount: employeeBenefitsData?.[graphDataKey]?.claimAmount ?? 0,
          nonEbClaimCount: nonEmployeeBenefitsData?.[graphDataKey]?.count ?? 0,
          nonEbClaimAmount:
            nonEmployeeBenefitsData?.[graphDataKey]?.claimAmount ?? 0,
        })
      })

      setGraphData(formattedGraphData)
    }
  }

  return (
    <>
      {employeeBenefitsData || nonEmployeeBenefitsData ? (
        <>
          <ResponsiveContainer
            width='100%'
            height='100%'
            minHeight='300px'
            className={'graph'}
          >
            <BarChart width={270} height={300} data={graphData} barSize={100}>
              <CartesianGrid strokeDasharray='3 3' />
              <XAxis dataKey='name' tick={<CustomAxisTick />} interval={0} />
              <YAxis
                yAxisId='left'
                orientation='left'
                stroke={COLORS?.DARK_PINK}
                tickFormatter={(value) => `${value.toFixed(1)}`}
              />
              <YAxis
                yAxisId='right'
                orientation='right'
                stroke={COLORS?.LIGHT_BLUE_01}
                tickFormatter={(value) => `${(value / 100000).toFixed(1)}L`}
              />
              <Tooltip
                position={{ x: 0, y: -40 }}
                content={<CustomGraphTooltip />}
              />
              <Legend
                layout='horizontal'
                margin={{ top: 0, left: 0, right: 0, bottom: 10 }}
                wrapperStyle={{
                  padding: '10px',
                  fontSize: '12px',
                }}
                verticalAlign='bottom'
              />
              <Bar
                yAxisId='left'
                name='EB Count'
                dataKey='ebClaimCount'
                fill={COLORS?.DARK_PINK}
              />
              <Bar
                yAxisId='right'
                name='EB Claim Amount'
                dataKey='ebClaimAmount'
                fill={COLORS?.LIGHT_BLUE_01}
              />
              <Bar
                yAxisId='left'
                name='Non-EB Count'
                dataKey='nonEbClaimCount'
                fill={COLORS?.BAR_CHART_COLOR1}
              />
              <Bar
                yAxisId='right'
                name='Non-EB Claim  Amount'
                dataKey='nonEbClaimAmount'
                fill={COLORS?.PALE_LIGHTBLUE}
              />
            </BarChart>
          </ResponsiveContainer>
        </>
      ) : (
        <p>Nil Claims</p>
      )}
    </>
  )
}

export default GeneralPendingClaimChart
